var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllusSexoMasc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#efebf6;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#9383bb;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_101",
    "data-name": "Elipse 101",
    className: "cls-1",
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1236",
    "data-name": "Grupo 1236"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_101-2",
    "data-name": "Elipse 101",
    className: "cls-2",
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.45,49C47.93,46.5,40,44.25,38.34,42.55V39.73s2.4-1,3-6.91c0,0,.85,0,.85-1.13a23.85,23.85,0,0,1,1.13-3.38c.28-.85.28-2-1.13-1.69l.08-.29h0v-.12c.09-.34.22-.87.34-1.53h-.14c.1-.81.23-1.84.35-2.86a6.93,6.93,0,0,0-3.38-7,18.07,18.07,0,0,0-10.72-2.26c-2.81.23-2.82,2-2.82,2-7.62,1.41-4.24,12.14-4.24,12.14-1.41-.29-1.41.84-1.12,1.69a23.68,23.68,0,0,1,1.12,3.38c0,1.13.85,1.13.85,1.13.57,5.93,3,6.91,3,6.91v2.82c-1.69,1.7-9.59,4-14.1,6.49-2.82,1.59-3.66,6-3.89,9.13A36.66,36.66,0,0,0,56.4,59.23C56.27,56.16,55.6,50.82,52.45,49ZM32.13,26.89h-.49l.51,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusSexoMasc);
export default __webpack_public_path__ + "static/media/illus_sexo_masc.bea51a962039d680ea4d42fd8b5b8997.svg";
export { ForwardRef as ReactComponent };